import React, { useRef } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";

// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-daterangepicker/daterangepicker.css";

import "./DatePicker.scss";

const DATE_FORMAT = "YYYY-MM-DD";

const DatePicker = ({ startDate, setStartDate, endDate, setEndDate }) => {

  const pickerRef = useRef(null);

  const today = moment();

  const ranges = {
    today: {
      start: today.clone(),
      end: today.clone()
    },

    yesterday: {
      start: today.clone().subtract(1, "day"),
      end: today.clone().subtract(1, "day")
    },

    week: {
      start: today.clone().startOf("isoWeek"),
      end: today.clone()
    },

    lastMonth: {
      start: today.clone().subtract(1, "month").startOf("month"),
      end: today.clone().subtract(1, "month").endOf("month")
    }
  };

  const isSameRange = (range) => {
    if (!startDate || !endDate) {
      return false;
    }

    return (
      moment(startDate).isSame(range.start, "day") &&
      moment(endDate).isSame(range.end, "day")
    );
  };

  const setRange = (range) => {
    const newStartDate = range.start.format(DATE_FORMAT);
    const newEndDate = range.end.format(DATE_FORMAT);

    setStartDate(newStartDate);
    setEndDate(newEndDate);

    if (pickerRef.current) {
      pickerRef.current.setStartDate(range.start);
      pickerRef.current.setEndDate(range.end);
    }
  };

  const handleCallback = (start, end) => {
    setStartDate(start.format(DATE_FORMAT));
    setEndDate(end.format(DATE_FORMAT));
  };

  const isCustomRange =
    startDate &&
    endDate &&
    !isSameRange(ranges.today) &&
    !isSameRange(ranges.yesterday) &&
    !isSameRange(ranges.week) &&
    !isSameRange(ranges.lastMonth);

  
  // для левой вспомогательной панели в календаре
  const ranges_left_panel = {
    "Последние 7 дней": [
      moment().subtract(6, "days"),
      moment()
    ],

    "Последние 30 дней": [
      moment().subtract(29, "days"),
      moment()
    ],

    "Последние 6 месяцев": [
      moment().subtract(6, "months"),
      moment()
    ],

    "Этот месяц": [
      moment().startOf("month"),
      moment()
    ]
  };

  return (
    <ul className="date-picker">
      <li
        className={isSameRange(ranges.today) ? "active" : ""}
        onClick={() => setRange(ranges.today)}
      >
        Сегодня
      </li>

      <li
        className={isSameRange(ranges.yesterday) ? "active" : ""}
        onClick={() => setRange(ranges.yesterday)}
      >
        Вчера
      </li>

      <li
        className={isSameRange(ranges.week) ? "active" : ""}
        onClick={() => setRange(ranges.week)}
      >
        Неделя
      </li>

      <li
        className={isSameRange(ranges.lastMonth) ? "active" : ""}
        onClick={() => setRange(ranges.lastMonth)}
      >
        Прошлый месяц
      </li>

      <li className={isCustomRange ? "active" : ""}>
        <DateRangePicker
          ref={pickerRef}
          initialSettings={{
            startDate: startDate ? moment(startDate) : moment(),
            endDate: endDate ? moment(endDate) : moment(),
            ranges: ranges_left_panel,
            locale: {
              format: "DD.MM.YYYY",
              applyLabel: "Применить",
              cancelLabel: "Отмена",
              customRangeLabel: "Другой период",
              daysOfWeek: [
                "Вс",
                "Пн",
                "Вт",
                "Ср",
                "Чт",
                "Пт",
                "Сб"
              ],
              monthNames: [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь"
              ]
            }
          }}
          onCallback={handleCallback}
        >
          <input
            type="text"
            className="date-picker-input"
          />
        </DateRangePicker>
      </li>
    </ul>
  );
};

export default DatePicker;